import { CateMenuListData, MenuListData } from "./model";

export type SearchChips = {
  popular: boolean;
  newItem: boolean;
  spicy: boolean;
  gf: boolean;   // gluetenFree (기존 오타 필드명)
  veg: boolean;
};

function matches(m: MenuListData, q: string, chips: SearchChips): boolean {
  if (q) {
    const hay = `${m.name} ${m.descr ?? ""}`.toLowerCase();
    if (!hay.includes(q)) return false;
  }
  if (chips.popular && !m.popular) return false;
  if (chips.newItem && !m.newItem) return false;
  if (chips.spicy && !m.spicy) return false;
  if (chips.gf && !m.gluetenFree) return false;
  if (chips.veg && !m.vegetarian) return false;
  return true;
}

// 클라이언트 사이드 필터. 매칭 0인 카테고리는 제거하고 원본은 변형하지 않는다.
export function filterCateMenus(
  cateMenus: CateMenuListData[],
  query: string,
  chips: SearchChips,
): CateMenuListData[] {
  const q = query.trim().toLowerCase();
  const out: CateMenuListData[] = [];
  for (const c of cateMenus) {
    const menus = c.menus.filter((m) => matches(m, q, chips));
    if (menus.length > 0) out.push({ ...c, menus });
  }
  return out;
}
